<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">Inland Cost:</p>
            <a href="#" class="card-header-icon">
              <span class="icon ">
                <i class="fas fa-truck"></i>
              </span>
            </a>
        </header>
        <div class="">
            <div class="content center inland-container">
                <table class="table" v-if="isModal">
                    <tbody>
                    <tr>
                        <th>Yokohama/Kawasaki:</th>
                        <th>Osaka/Kobe:</th>
                        <th>Nagoya:</th>
                        <th>Hakata:</th>

                    </tr>
                    <tr>
                        <td class="has-text-danger">{{ yokohama }}</td>
                        <td class="has-text-danger">{{ osaka }}</td>
                        <td class="has-text-danger">{{ nagoya }}</td>
                        <td class="has-text-danger">{{ hakata }}</td>
                    </tr>
                    </tbody>
                </table>
                <table class="table" v-else>
                    <tbody>
                    <tr>
                        <th>Yokohama/Kawasaki:</th>
                        <td class="has-text-danger">{{ yokohama }}</td>
                    </tr>
                    <tr>
                        <th>Osaka/Kobe:</th>
                        <td class="has-text-danger">{{ osaka }}</td>
                    </tr>
                    <tr>
                        <th>Nagoya:</th>
                        <td class="has-text-danger">{{ nagoya }}</td>
                    </tr>
                    <tr>
                        <th>Hakata:</th>
                        <td class="has-text-danger">{{ hakata }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import apiInlandPrice from './../../../api/apiInlandPrice'
    import numeral from 'numeral'

    export default {
        props: ['lot', 'type'],
        data() {
            return {
                yokohama: '',
                osaka: '',
                nagoya: '',
                hakata: '',
                query: {
                    auction: this.lot.auction_name
                }
            }
        },
        methods: {
            getPriceNumber(value) {
                return value == '0¥' ? 'Ask' : value
            }
        },
        computed: {
            isModal() {
                return this.type == 'modal' ? true : false;
            }
        },
        created() {
            apiInlandPrice
                .requestAuctionDeliveryPrices(this.query)
                .then((response) => {
                    this.yokohama = response.data.yokohama_sales === 'NaN' ? 'Ask' : this.getPriceNumber(response.data.yokohama_sales)
                    this.osaka = response.data.osaka_sales === 'NaN' ? 'Ask' : this.getPriceNumber(response.data.osaka_sales)
                    this.nagoya = response.data.nagoya_sales === 'NaN' ? 'Ask' : this.getPriceNumber(response.data.nagoya_sales)
                    this.hakata = response.data.hakata_sales === 'NaN' ? 'Ask' : this.getPriceNumber(response.data.hakata_sales)
                })
                .catch((error) => {
                    console.log(error)
                })
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Tools/Calculators/InlandCost.vue